import { RemoteTagManager } from "divine-binary-tags";
export const RegionTags = new RemoteTagManager("region-tags");
export const RegionHeaderTags = new RemoteTagManager("region-header-tags");
